import { Injectable } from '@angular/core';

import moment from 'moment-timezone';

import { TimeTranslations, TranslationsProvider } from '@core/i18n-legacy';
import { includesWithTrim } from '@core/utils-legacy';

@Injectable({ providedIn: 'root' })
export class TimeAgoBase {
  protected locales: string[] = this.translationsProvider.availableLocales;
  protected defaultLocale: string = this.translationsProvider.defaultLocale;
  protected translations: Record<string, Array<[string, string]>> = TimeTranslations;

  constructor(private translationsProvider: TranslationsProvider) {}

  public getTime(
    value: moment.MomentInput,
    { omitSuffix, shortWithSuffix }: { omitSuffix: boolean; shortWithSuffix?: boolean },
  ): string {
    if (!shortWithSuffix) {
      const timeAgo = moment(value).fromNow(omitSuffix);
      return omitSuffix ? this.stringReplace(timeAgo, value) : timeAgo;
    }

    return this.shortTimeAgoWithSuffix(value);
  }

  private shortTimeAgoWithSuffix(value: moment.MomentInput): string {
    const timeAgoWithoutSuffix = moment(value).fromNow(true);
    const shortTimeAgo = this.stringReplace(timeAgoWithoutSuffix, value);
    return moment(value).fromNow().replace(timeAgoWithoutSuffix, shortTimeAgo);
  }

  private getCurrentLang(): string {
    const momentLang = moment.locale();

    if (this.locales.includes(momentLang)) {
      return momentLang;
    } else {
      return this.defaultLocale;
    }
  }

  private stringReplace(timeAgo: string, value: moment.MomentInput): string {
    let time = '';
    const currentLang = this.getCurrentLang();

    if (this.isFinnishLanguage(currentLang) && this.isDateInTheFuture(value)) {
      this.translations[currentLang]?.forEach(pair => {
        if (includesWithTrim(timeAgo, pair[0], { trim: false })) {
          time = this.isFirstWord(pair[0], timeAgo)
            ? timeAgo.replace(pair[0], `1 ${pair[1]}`)
            : timeAgo.replace(pair[0], pair[1]);
        }
      });
      return time;
    }

    this.translations[currentLang]?.forEach(pair => {
      if (timeAgo.toLowerCase().indexOf(pair[0].toLowerCase()) !== -1) {
        time = timeAgo.replace(pair[0], pair[1]);
      }
    });

    return time;
  }

  private isFirstWord(word: string, sentence: string): boolean {
    return sentence.toLowerCase().trim().indexOf(word.toLowerCase()) === 0;
  }

  private isFinnishLanguage(language: string): boolean {
    return language === 'fi';
  }

  private isDateInTheFuture(date: moment.MomentInput): boolean {
    return moment(date).diff(moment(), 'second') > 0;
  }
}
